import QRCode from "qrcode";

export const generateQR = async (text: string | undefined) => {
  if (text) {
    try {
      const res = await QRCode.toDataURL(text);
      return res;
    } catch (err) {
      console.warn(err);
    }
  }
};
